import { FormValidator, type FormValidatorConfig, type FormValidatorSettings } from '../models';
import { isEmpty } from '../utils';
import { getStrippedValue } from '../utils/validartor.utils';

export interface RequiredValidatorSettings extends FormValidatorSettings {
  stripTags?: boolean;
}

export type RequiredValidatorConfig = FormValidatorConfig<RequiredValidatorSettings>;

export class RequiredValidator extends FormValidator<RequiredValidatorSettings> {
  constructor() {
    super();
    this._name = 'required';
    this._settings = {
      invalidMessage: 'form.validator.required.invalidMessage',
      needTranslate: true,
      stripTags: false
    };
  }

  public override async onValidate(value: any) {
    value = this._settings.stripTags ? getStrippedValue(value) : value;

    this._valid = !isEmpty(value);

    if (!this._valid) {
      this.addMessage(this._settings.invalidMessage);
    }
  }
}
